import { Form, Input } from "antd";
import moment from "moment";

export const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  // Define a validator function to check if the input is a valid date
  const dateValidator = (_, value) => {
    if (value && !moment(value, "MM-DD-YYYY", true).isValid()) {
      return Promise.reject(new Error(`Invalid date for ${title}!`));
    }
    return Promise.resolve();
  };

  let rules = [
    {
      required: true,
      message: `Please Input ${title}!`,
    },
  ];

  // Apply date validator if dataIndex is 'dateRegistered' or 'expirationDate'
  if (dataIndex === "dateRegistered" || dataIndex === "expirationDate") {
    rules.push({
      validator: dateValidator,
    });
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item name={dataIndex} style={{ margin: 0 }} rules={rules}>
          {inputType === "date" ? <Input /> : <Input />}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
